<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-xl" @reset="reset">
                <template v-slot:filter>
                    <select v-model="form.trashed" class="form-select w-28">
                        <option :value="null">Filter</option>
                        <option value="with">With Trashed</option>
                        <option value="only">Only Trashed</option>
                    </select>
                </template>
                <template v-slot:page>
                    <select v-model="form.length" class="form-select w-20">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                    </select>
                </template>
            </search-filter>
            <Button :type="type" :name="title" :url="createUrl" v-if="permission.add > 0"></Button>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <thead>
                    <tr class="text-left font-bold">
                        <th class="pb-4 pt-6 px-6">Title</th>
                        <th class="pb-4 pt-6 px-6">Category</th>
                        <th class="pb-4 pt-6 px-6">Order</th>
                        <th class="pb-4 pt-6 px-6">Status</th>
                        <th class="pb-4 pt-6 px-6" colspan="2"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="userManual in userManuals.data" :key="userManual.id"
                        class="hover:bg-gray-100 focus-within:bg-gray-100">
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4 focus:text-orange-500"
                                :href="`/backend/user-manuals/${userManual.id}/edit`">
                            {{ userManual.title }}
                            <icon v-if="userManual.deleted_at" name="trash"
                                class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                            </Link>
                        </td>
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4"
                                :href="`/backend/user-manuals/${userManual.id}/edit`" tabindex="-1">
                            {{ userManual.cat_name }}
                            </Link>
                        </td>
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4"
                                :href="`/backend/user-manuals/${userManual.id}/edit`" tabindex="-1">
                            {{ userManual.order }}
                            </Link>
                        </td>
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4"
                                :href="`/backend/user-manuals/${userManual.id}/edit`" tabindex="-1">
                            <status-level :status="userManual.status"></status-level>
                            </Link>
                        </td>
                        <td class="w-px border-t">
                            <div class="flex items-center px-2" v-if="permission.edit > 0">
                                <Link class="px-4 py-2" :href="`/backend/user-manuals/${userManual.id}/edit`"
                                    tabindex="-1">
                                <i class="fa fa-edit"></i>
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="userManuals.data.length === 0">
                        <td class="px-6 py-4 border-t" colspan="5">No User Manual found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <pagination class="mt-6" :links="userManuals.links" />
    </div>
</template>

<script>
    import Breadcrumbs from '@/Shared/Breadcrumbs'
    import Button from '@/Shared/Button'
    import Icon from '@/Shared/Icon'
    import Layout from '@/Shared/Layout'
    import Pagination from '@/Shared/Pagination'
    import SearchFilter from '@/Shared/SearchFilter'
    import StatusLevel from '@/Shared/StatusLevel'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import mapValues from 'lodash/mapValues'
    import pickBy from 'lodash/pickBy'
    import throttle from 'lodash/throttle'
    import { ref, toRefs, inject } from 'vue'

    export default {
        components: {
            Head,
            Icon,
            Link,
            Pagination,
            SearchFilter,
            Breadcrumbs,
            StatusLevel,
            Button
        },
        layout: Layout,
        props: {
            filters: Object,
            userManuals: Object,
            permission: Object,
        },
        setup(props) {
            const { filters, userManuals, permission } = toRefs(props)
            const form = ref({
                search: filters.value.search,
                trashed: filters.value.trashed,
                length: filters.value.length ? filters.value.length : 15,
                status: filters.value.status,
            })
            const type = ref('index')
            const title = ref('User Manuals')
            const url = ref('')
            const createUrl = ref('/backend/user-manuals/create')
            const reset = () => {
                form.value = mapValues(form.value, () => null)
            }
            return {
                filters,
                form,
                userManuals,
                reset,
                type,
                title,
                url,
                createUrl,
                permission
            }
        },
        watch: {
            form: {
                deep: true,
                handler: throttle(function () {
                    this.$inertia.get('/backend/user-manuals', pickBy(this.form), { preserveState: true })
                }, 150),
            },
        },
    }
</script>
